import React from 'react'
import './snipper.css'
function Snipper() {
  return (
    <div id="loading"  ></div>
  )
}

export default Snipper